import React from "react";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

class DocumentHtmlShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isLoad: true,
      invoice_content: "",
      invoice_name: "",
    };

    // ✅ Print & PDF için referans
    this.invoiceWrapperRef = React.createRef();
  }

  componentDidMount() {
    this.getInvoiceContent();
  }

  getInvoiceContent = async () => {
    const { id } = this.props.match.params;

    try {
      const response = await apiCall(
          `business/ksoft/document-link/${id}`,
          "get",
          null
      );

      this.setState({
        invoice_content: response.content,
        invoice_name: response.name,
        isLoad: false,
      });
    } catch (e) {
      this.setState({ isLoad: false });
      mainHelper.toastMessage(e.status, e.message);
    }
  };

  // ✅ PDF İndirme – sadece wrapper'ı canvas'a çeviriyoruz
  handleDownload = async () => {
    const wrapper = this.invoiceWrapperRef.current;
    if (!wrapper) return;

    this.setState({ loading: true });

    try {
      const canvas = await html2canvas(wrapper, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pdfWidth - 20; // kenardan 10mm boşluk
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let position = 10;
      let heightLeft = imgHeight;

      // İlk sayfa
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // İçerik tek sayfaya sığmazsa, diğer sayfaları ekle
      while (heightLeft > 0) {
        position = heightLeft - imgHeight + 10;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      this.setState({ loading: false });
      pdf.save(this.state.invoice_name || "fatura.pdf");
    } catch (error) {
      console.error("PDF oluşturma hatası:", error);
      this.setState({ loading: false });
      alert("PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyiniz.");
    }
  };

  // ✅ Print – yine sadece wrapper'ın içeriğini yeni pencerede basıyoruz
  handlePrint = () => {
    const wrapper = this.invoiceWrapperRef.current;
    if (!wrapper) {
      console.error("Yazdırılacak içerik bulunamadı.");
      return;
    }

    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Fatura Yazdır</title>
        <meta charset="UTF-8" />
        <style>
          * {
            box-sizing: border-box;
          }
          html, body {
            margin: 0;
            padding: 0;
            background: #fff;
          }

          /* 🔹 içerik kartı - minimal müdahale */
          .invoice-card {
            margin: 0 auto;
            padding: 10mm;
            max-width: 800px;
            width: 100%;
            background: #fff;
            text-align: left;
            overflow-x: auto;
            overflow-y: visible;
          }

          /* Sadece resimler için boyut kontrolü */
          .invoice-card img {
            max-width: 100%;
            height: auto;
          }

          /* Tablolar için sadece max-width */
          .invoice-card table {
            max-width: 100%;
          }

          /* Uzun kelimeler için */
          .invoice-card {
            overflow-wrap: break-word;
            word-break: break-word;
          }

          @media print {
            @page {
              size: auto;
              margin: 0;
            }
            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
              background: #fff;
            }
            .invoice-card {
              margin: 0 auto;
              padding: 10mm;
              width: 100%;
              max-width: 800px;
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="invoice-card">
          ${wrapper.innerHTML}
        </div>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = () => window.close();
          };
        </script>
      </body>
    </html>
  `);
    printWindow.document.close();
  };


  render() {
    const { isLoad, invoice_content, loading } = this.state;

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
              document.body.classList.remove("offcanvas-active");
            }}
        >
          {/* Yükleniyor ekranı */}
          {isLoad && (
                <div className="page-loader-wrapper" style={{ display: 'flex', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#49c5b6', zIndex: 9999, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                  <div className="m-t-30">
                    <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
                  </div>
                  <p style={{color: '#fff', marginTop: '20px'}}>Yükleniyor</p>
                  <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                </div>
          )}

          {/* İçerik */}
          {!isLoad && (
              <div style={containerStyle}>
                <style>{invoiceContentStyles}</style>
                <div className="card">
                  <div className="body">
                    {/* ✅ Minimal taşma kontrolü - orijinal stilleri koruyarak */}
                    <div
                        ref={this.invoiceWrapperRef}
                        className="invoice-card"
                        style={{
                          margin: "0 auto",
                          maxWidth: "800px",
                          width: "100%",
                          backgroundColor: "#ffffff",
                          overflowX: "auto",
                          overflowY: "visible",
                        }}
                    >
                      {invoice_content ? (
                          <div
                              className="post__content invoice-content-wrapper"
                              dangerouslySetInnerHTML={{
                                __html: invoice_content,
                              }}
                          />
                      ) : (
                          <div className="alert-warning text-center">
                            Fatura İçeriği Bulunamadı!
                          </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Butonlar */}
                <div
                    className="row justify-content-center"
                    style={{ marginTop: "15px" }}
                >
                  <div className="col-auto">
                    <button
                        onClick={this.handlePrint}
                        className="text-center btn btn-outline-secondary"
                    >
                      <i className="fa fa-print"></i>&nbsp;&nbsp;Yazdır
                    </button>
                  </div>

                  <div className="col-auto">
                    {loading ? (
                        <button className="btn btn-outline-success btn-block" disabled={true}
                                style={{textAlign: "-webkit-center"}}>
                                Lütfen Bekleyin...
                        <ReactLoading type="spin"
                                width={'24px'}
                                height={'24px'}
                                color="#268bd2">
                        </ReactLoading>
                        </button>
                    ) : (
                        <button
                            onClick={this.handleDownload}
                            className="text-center btn btn-outline-success"
                        >
                          <i className="fa fa-file-pdf-o"></i>
                          &nbsp;&nbsp;Pdf İndir
                        </button>
                    )}
                  </div>
                </div>
              </div>
          )}
        </div>
    );
  }
}

const containerStyle = {
  margin: "0 auto",
  maxWidth: "900px",
  width: "100%",
  padding: "20px",
  backgroundColor: "#fff",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
};

// ✅ Minimal taşma önleme - Orijinal fatura stillerini bozmadan
const invoiceContentStyles = `
  .invoice-content-wrapper {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: visible;
  }

  /* Sadece container'dan taşan resimleri kontrol et */
  .invoice-content-wrapper img {
    max-width: 100%;
    height: auto;
  }

  /* Tablolar kendi stillerini korusun, sadece taşmayı engelle */
  .invoice-content-wrapper table {
    max-width: 100%;
  }

  /* Çok uzun kelimeler için minimal müdahale */
  .invoice-content-wrapper {
    overflow-wrap: break-word;
    word-break: break-word;
  }
`;

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(DocumentHtmlShow);
